import { css } from 'styled-components';
export const flexboxKeys = [
    'alignItems',
    'alignContent',
    'justifyItems',
    'justifyContent',
    'flexWrap',
    'flexDirection',
    'flex',
    'flexGrow',
    'flexShrink',
    'flexBasis',
    'gap',
    'columnGap',
    'rowGap',
    'justifySelf',
    'alignSelf',
    'order',
];
export const flexbox = css `
  ${({ $alignItems, $alignContent, $justifyItems, $justifyContent, $flexWrap, $flexDirection, $flex, $flexGrow, $flexShrink, $flexBasis, $gap, $columnGap, $rowGap, $justifySelf, $alignSelf, $order, }) => `
    ${$alignItems ? `align-items: ${$alignItems};` : ''}
    ${$alignContent ? `align-content: ${$alignContent};` : ''}
    ${$justifyItems ? `justify-items: ${$justifyItems};` : ''}
    ${$justifyContent ? `justify-content: ${$justifyContent};` : ''}
    ${$flexWrap ? `flex-wrap: ${$flexWrap};` : ''}
    ${$flexDirection ? `flex-direction: ${$flexDirection};` : ''}
    ${$flex ? `flex: ${$flex};` : ''}
    ${$flexGrow ? `flex-grow: ${$flexGrow};` : ''}
    ${$flexShrink ? `flex-shrink: ${$flexShrink};` : ''}
    ${$flexBasis ? `flex-basis: ${$flexBasis};` : ''}
    ${$gap ? `gap: ${$gap}px;` : ''}
    ${$columnGap ? `column-gap: ${$columnGap}px;` : ''}
    ${$rowGap ? `row-gap: ${$rowGap}px;` : ''}
    ${$justifySelf ? `justify-self: ${$justifySelf};` : ''}
    ${$alignSelf ? `align-self: ${$alignSelf};` : ''}
    ${$order ? `order: ${$order};` : ''}
  `}
`;
